angular.module('impactx.controlstructure').controller('CTRLACtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    CTRLACtrl
]);

function CTRLACtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/ctrla/view";
    $scope.endPointSave = "/control/ctrla/save";
    $scope.endPointDelete = "/control/ctrla/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.ctrla.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.ctrla.readOnly && !$scope.data.ctrla.deprecated;
    }
}